import styled from "styled-components";
import {easings} from 'react-animation'
import { Link } from "react-router-dom";

import { useSelector } from "react-redux";

import { selectUserName} from "../features/users/userSlice";



const Hero = (props) =>{

    const style = {
        animation: `pop-in ${easings.easeOutExpo} 1500ms forwards`
    }

    const userName = useSelector(selectUserName);

    console.log(userName);
    return(
        <Container>
            <Content>
                <CTA>
                    <div className="hero__caption">
                        <div className="hero__caption__one">
                            <Title style ={style}>
                                <p> {userName ? `Welcome ${userName}`: "Welcome"}</p>
                                <h1>Start or grow your own business</h1>
                            </Title>
                            <Description>
                                <p>Welcome to the future <b>"Winnthako Enterprise"</b> best in handling financial matters and wealth creation. Reliable, Credible and Accessible</p>
                            </Description>
                            <a href="#apply-loan" className="viewBtn">Take a Loan</a>
                            <Link to ='/partner' className="viewBtn">Be an Investor</Link> 
                            {/* <Social> Follow us - </Social> */}
                        </div>
                        {/* <div className="hero__caption__two socials">
                            <h3>Social links here for you</h3>
                        </div> */}
                    </div>
                    <Niche>
                        <div>
                            <span><i class="fa fa-university" aria-hidden="true"></i></span>
                            <div>Quick <br/> Loan approvals</div>
                        </div>
                        <div>
                            <span><i class="fa fa-university" aria-hidden="true"></i></span>
                            <div>100% <br/> Customers satisfaction</div>
                        </div>
                        <div>
                            <span><i class="fa fa-university" aria-hidden="true"></i></span>
                            <div>No repayment or <br /> hidden fees</div>
                        </div>
                    </Niche>
                </CTA>
            </Content>
            <BgImage></BgImage>
        </Container>
    )
}


const Container = styled.div`
    color: rgb(255, 255, 255);
    display: flex;
    flex-direction: column;
    z-index: 1;
    position: relative;
    background: black;
    overflow: hidden;
    p{
        color: rgb(255, 255, 255);
    }
`
const BgImage = styled.div`
    background-image: linear-gradient(rgba(0,0,0,0.3),rgba(0,0,0,0.3)), url('https://templates.envytheme.com/finix/default/assets/img/main-banner.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-attachment: fixed;
    position: absolute;
    opacity: 0.3;
    top: 0;
    height: 100%;
    width: 100vw;
    z-index: -1;

`
const Content = styled.div`

    @media(max-width: 768px){
        padding: 50px 20px 20px;
    }
    

`


const Social = styled.div`
    display: flex;
    margin-bottom: 20px;
    justify-content: space-between;
`
const Niche = styled.div`
    display: flex;
    flex-direction: column;

    @media(min-width: 768px){
        flex-direction: row; 
    }

    >div{
        display: flex;
        padding: 30px 20px;
        align-items: center;
        border-top: 1px solid rgb(156, 162, 160);

        div{
            margin-left: 20px;
        }

        span{
           font-size:40px; 
           color: rgb(231, 60, 76);
        }

        @media(min-width: 768px){
            flex-grow: 1;
            border-right: 1px solid rgb(156, 162, 160);
        }
    }

`
 


 
const CTA = styled.div`
   @media(min-width: 768px){
    .hero__caption{
        padding: 100px 20px;
        justify-content: space-between;
        display: flex;
        
        .hero__caption__one, .socials{
            width: 50%;
        }
        .socials{
            display: flex;
            position: relative;
            right: -130px;
            top: 100px;
            transform: rotate(90deg);
        }
        h3{
            color: rgb(255, 255, 255);
        }
    }
   }
    .viewBtn{
        background: rgb(231, 60, 62);
        padding: 15px 40px;
        display: inline-block;
        margin-right: 20px;
        border-radius: 3px;
        cursor: pointer;
        display: inlline-block;
        margin-bottom: 20px;
        color: #fff;

        @media(max-width: 768px){
            text-align: center;
            padding: 10px 12px;
            min-width: 100px;
        }
    }

`

// Others
const Title = styled.div``
const Description = styled.div`

    
    `










export default Hero